import { FerramentaVideoService } from 'core/http/service/ferramentaVideo/FerramentaVideo.service';
import { IFVRole, IFVRoleAction } from 'pages/ferramentaVideo/interfaces/FVRole.interface';
import { useMutation, useQuery, useQueryClient } from 'react-query';

const service = new FerramentaVideoService();


const fetchRoles = async (id: number): Promise<IFVRole[]> => {
    const { data } = await service.fetchRolesByContainerId(id);
    return data;
}

const createRole = async (idContainer: number, dataForm: IFVRoleAction) => {
    const { data } = await service.createRole(idContainer, dataForm);
    return data;
};

const updateRole = async (idRole: number, dataForm: IFVRoleAction) => {
    const { data } = await service.updateRole(idRole, dataForm);
    return data;
};

const deleteRole = async (idRole: number) => {
    const { status } = await service.deleteRole(idRole);
    return status;
};

export function useFVRoles(idContainer: number) {
    const queryClient = useQueryClient();

        const listQueryRoles = useQuery<IFVRole[]>(['roles', idContainer], async ({ queryKey }) => {
            const [, id] = queryKey as [string, number];
            return fetchRoles(id);
        });
    

    const createRoleMutation = useMutation((dataForm: IFVRoleAction) => createRole(idContainer, dataForm), {
        onSuccess: () => {
            queryClient.invalidateQueries('containerToolUnique');
        },
    });

    const updateRoleMutation = useMutation(({ idRole, dataForm }: { idRole: number; dataForm: IFVRoleAction }) => updateRole(idRole, dataForm), {
        onSuccess: () => {
            queryClient.invalidateQueries('containerToolUnique');
        },
    });

    const deleteRoleMutation = useMutation((idRole: number) => deleteRole(idRole), {
        onSuccess: () => {
            queryClient.invalidateQueries('containerToolUnique');
        },
    });

    return {
        listQueryRoles,
        createRoleMutation,
        updateRoleMutation,
        deleteRoleMutation,
    };
}
